import React from 'react';
import DynamicRoutingAnimation from '../../../../DialogAnimations/DynamicRoutingAnimation';
import * as ValidateInputAnimation from '../../../../DialogAnimations/ValidationAnimation.json';
import { Dialog, DialogContent, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  dialogContainer: {
    padding: 16,
    userSelect: 'none',
    backgroundColor: theme.ModalBGColor,
    maxWidth: '80vw',
    minWidth: 600,
    minHeight: 600
  },
  dialogContent: {
    padding: '30px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px'
  },
  title: {
    color: theme.disableButtonText,
    fontSize: theme.headerTextFontSize16,
    fontWeight: 600
  },
  subtitle: {
    color: theme.gridTextColor,
    fontSize: theme.headerTextFontSize
  }
});

const ReviewProgressAnimationDialog = ({ classes, show }) => {
  return (
    <Dialog open={show} classes={{ paper: classes.dialogContainer }}>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.title}>
          Reviewing shipment details to ensure the best route optimization.
        </div>
        <div className={classes.subtitle}>
          Accurate shipment details lead to more efficient city routes.
        </div>
        <DynamicRoutingAnimation dimension={300} animationJSON={ValidateInputAnimation.default} />
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(ReviewProgressAnimationDialog);
